<div class="dialog-container mb-2">
  <div class="dialog-icon">
    <img src="assets/images/unpublish.svg" class="img-fluid icon mb-3" alt="icon">
  </div>

  <h2 class="dialog-title">Unpublish Course?</h2>

  <p class="dialog-text">
    If you unpublish this course, it will no longer be visible to students. The
    course will be saved as a draft.
  </p>

  <div class="text-center">
    <button class="btn-cancel me-4 p-2" (click)="onCancel()">Cancel</button>
    <button class="btn-add" (click)="onRemove()">Yes, Unpublish</button>
  </div>
</div>